<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="100px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" filterable placeholder="请选择">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matName" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.orderCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col>



                <el-col :lg="5" :xl="5">
                    <el-form-item label="退货单号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.srCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="退货状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.srStatus" clearable="clearable">
                            <el-option key="1" value="CREATE,PICK,PICKING,PICKCOMPLETE,TEMP" label="默认（未完成）"></el-option>
                            <!-- <el-option key="1" value="CREATE" label="创建"></el-option>
                            <el-option key="2" value="PICK" label="提交拣配"></el-option> -->
                            <el-option key="3" value="PICKING" label="拣配中"></el-option>
                            <el-option key="4" value="PICKCOMPLETE" label="拣货完成"></el-option>
                            <el-option key="9" value="TEMPOUT" label="完成"></el-option>
                            <!-- <el-option key="7" value="OUTPUT" label="已出库"></el-option> -->
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="仓库类型" class="EL-Form-Item">
                  <el-select v-model="mainSearch.saleFlag" clearable="clearable">
                    <el-option key="1" value="" label="全部"></el-option>
                    <el-option key="3" value="1" label="寄售仓"></el-option>
                    <el-option key="4" value="0" label="非寄售仓"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="供应商" class="EL-Form-Item">
                  <el-input v-model="mainSearch.svName" placeholder="请输入" @change="saveSearch()"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="采购退货单">
                <el-button v-authority="'BACK_MENU3_M15_B1'" class="btn-t-edit" @click="getPrintList()">单据打印</el-button>
                <el-button v-authority="'BACK_MENU3_M15_B2'" class="btn-t-edit" @click="whInventoryOpen()">申请退货</el-button>
                <!-- <el-button v-authority="'BACK_MENU3_M15_B3'" class="btn-t-edit" @click="ReturnConfirmationVR()">确认出库</el-button> -->
                <!-- <el-button v-authority="'BACK_MENU3_M15_B4'" class="btn-t-edit" @click="ReturnConfirmation()">暂存库位</el-button> -->
                <el-button v-authority="'BACK_MENU3_M15_B5'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" :row-class-name="tableRowClassNames" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" ref="hTable" @selectionChange="selectAll">
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
              <!-- <el-table-column label="供应商" align="center" prop="svName">
               </el-table-column>-->
                <el-table-column label="箱原始数量" align="center" prop="matOldQuan">
                </el-table-column>
                <el-table-column label="退货数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="拣货数量" align="center" prop="matPickQuan">
                </el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode">
                </el-table-column>
              <!-- <el-table-column label="仓库类型" align="center" prop="orderCode">
                   <template slot-scope="scope">
                       <span v-if="scope.row.orderCode">{{scope.row.orderCode.substring(0,1) === 'P' ? '非寄售' : '寄售'}}</span>
                   </template>
               </el-table-column>-->
                <el-table-column label="退料单" align="center" prop="srCode">
                </el-table-column>
                <el-table-column label="状态" align="center" prop="srStatus">
                    <template slot-scope="scope">
                        <div v-if="scope.row.srStatus == 'CREATE'">创建</div>
                        <div v-if="scope.row.srStatus == 'PICK'">提交拣配</div>
                        <div v-if="scope.row.srStatus == 'PICKING'">拣配中</div>
                        <div v-if="scope.row.srStatus == 'WAITOUT'">待出库</div>
                        <div v-if="scope.row.srStatus == 'TEMP'">暂存</div>
                        <div v-if="scope.row.srStatus == 'TEMPOUT'">完成</div>
                        <div v-if="scope.row.srStatus == 'OUTPUT'">已出库</div>
                        <div v-if="scope.row.srStatus == 'CONFIRM'">完成</div>
                    </template>
                </el-table-column>
                <el-table-column label="退货日期" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="退货人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="仓库类型" align="center" prop="person">
                  <template slot-scope="scope">
                    <div v-if="scope.row.saleFlag">寄售仓</div>
                    <div v-if="scope.row.saleFlag!=null&&!scope.row.saleFlag">非寄售仓</div>

                  </template>
                </el-table-column>
              <el-table-column label="供应商" align="center" prop="svName">
              </el-table-column>
                <el-table-column label="操作" min-width="240" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU3_M15_B6'" class="btn-t-edit" @click="detailsDialog(scope.row)">查看</el-button>
                        <el-button :disabled="scope.row.srStatus !='CREATE'?true:false" v-authority="'BACK_MENU3_M15_B8'" size="mini" class="btn-t-edit" @click="submitPicking(scope.row)">拣货确认</el-button>
                        <el-button :disabled="scope.row.srStatus !='CREATE'?true:false" v-authority="'BACK_MENU3_M15_B7'" class="btn-t-edit" @click="deleteReturn(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 采购退货列表 -->
        <el-dialog title="采购退货列表" :visible.sync="detailsDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.88)" :close-on-click-modal="false" :show-close="false">
            <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.73)" :data="mainDetails">
                <el-table-column label="订单编号" align="center" prop="orderCode">
                </el-table-column>
                <el-table-column label="退料单号" align="center" prop="srCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="计划退货数量" align="center" prop="matQuan">
                    <template slot-scope="scope">
                        <span v-if="scope.row.whType =='20' && scope.row.srStatus =='CREATE'">
                            <span v-if="scope.row.clicktext" @change="updateStockReturn(scope.row)" @keyup.enter="updateStockReturn(scope.row)">
                                <el-input v-model="scope.row.matQuan">
                                </el-input>
                            </span>
                            <span v-else>
                                {{ scope.row.matQuan }}
                                <span @click="tabClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                            </span>
                        </span>
                        <span v-else>
                            {{ scope.row.matQuan }}
                        </span>

                    </template>
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs" >
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="库位" align="center" prop="laCodeAdvise">
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <!-- <el-table-column label="拣配单号" align="center" prop="spCode">
                </el-table-column> -->
                <el-table-column label="拣配状态" align="center" prop="spStatus">
                    <template slot-scope="scope">
                        <div v-if="scope.row.srStatus == 'CREATE'">创建</div>
                        <div v-if="scope.row.srStatus == 'PICK'">提交拣配</div>
                        <div v-if="scope.row.srStatus == 'PICKING'">拣配中</div>
                        <div v-if="scope.row.srStatus == 'WAITOUT'">拣配完成</div>
                        <div v-if="scope.row.srStatus == 'TEMP'">暂存</div>
                        <div v-if="scope.row.srStatus == 'TEMPOUT'">完成</div>
                        <div v-if="scope.row.srStatus == 'OUTPUT'">已出库</div>
                        <div v-if="scope.row.srStatus == 'CONFIRM'">完成</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogClose" size="mini" type="info">关 闭</el-button>
                <!--<el-button :disabled='buttonShow' v-authority="'BACK_MENU3_M15_B8'" size="mini" class="btn-t-edit" @click="submitPicking">拣货确认</el-button>-->
            </div>
        </el-dialog>

        <!-- 库存详情 -->
        <el-dialog title="库存详情" :visible.sync="whInventoryShow" class="fromDialog" :style="$popups.popups(0.8,0.88)" :close-on-click-modal="false" :show-close="false">
            <el-form label-position="right" label-width="100px">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="采购订单" class="EL-Form-Item">
                        <el-input v-model="whInventorySearch.opCode" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="whInventorySearch.whCode" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="whInventorySearch.matCode" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="whInventorySearch.matName" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getStockList">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetStock">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料批次" class="EL-Form-Item">
                        <el-input v-model="whInventorySearch.batchNo" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input v-model="whInventorySearch.lcCode" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="whInventorySearch.boxBarcode" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料状态" class="EL-Form-Item">
                        <el-select v-model="whInventorySearch.wiStatus" placeholder="请选择">
                            <el-option label="正常" value="NORMAL" />
                            <el-option label="冻结" value="AGFREEZE" />
                        </el-select>
                    </el-form-item>
                </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="仓库类型" class="EL-Form-Item">
                  <el-select v-model="whInventorySearch.saleFlag" placeholder="请选择">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option label="寄售仓" value="1" />
                    <el-option label="非寄售仓" value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="供应商" class="EL-Form-Item">
                  <el-select v-model="whInventorySearch.verdorCode" filterable placeholder="请选择">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option v-for="item in vendorList" :key="item.svId" :value="item.svId" :label="item.svId">{{item.svId}}</el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="质检状态" class="EL-Form-Item">
                  <el-select v-model="whInventorySearch.checkResult" placeholder="请选择">
                    <!--<el-option label="全部" value="" />-->
                    <el-option label="合格" value="20" />
                    <el-option label="不合格" value="30" />
                    <el-option label="退货" value="40" />
                  </el-select>
                </el-form-item>
              </el-col>

            </el-form>
            <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.55)" @pageChange="getStockList()" :data="whInventoryDialog.data" pagination :nowPage.sync="whInventoryDialog.nowPage" :pageSize.sync="whInventoryDialog.pageSize" :total.sync="whInventoryDialog.total" ref="hTable" @selectionChange="checkAllWh">
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>

                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="已分配数量" align="center" prop="matDistrQuan">
                </el-table-column>
                <el-table-column label="物料退货数量" align="center" prop="returnNum">
                    <template slot-scope="scope">
                        <span v-if="scope.row.whType=='10'">{{scope.row.returnNum}}</span>
                        <el-input v-model="scope.row.returnNum" v-else @input="maxReturnNum($event,scope.$index)" @change="maxReturnNum($event,scope.$index)"></el-input>
                        <!-- <el-input v-model="scope.row.returnNum" oninput="value=value.replace(/[^\d]/g,'')"></el-input> -->
                    </template>
                </el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="库位编号" align="center" prop="lcCode">
                </el-table-column>
                <el-table-column label="箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode">
                </el-table-column>
                <el-table-column label="仓库类型" align="center" prop="saleFlag">
                  <template slot-scope="scope">
                    {{ scope.row.saleFlag ? '寄售仓' : '非寄售仓' }}
                  </template>
                </el-table-column>
                <el-table-column label="供应商" align="center" prop="verdorCode">
                </el-table-column>
                <el-table-column label="供应商名称" align="center" prop="svName">
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" width="100px">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime" width="100px">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" @click="whInventoryClose()" type="info">取 消</el-button>
                <el-button :loading="confrimReturns" size="mini" class="btn-t-edit" @click="confrimReturn()">确认</el-button>
            </div>
        </el-dialog>

        <!-- 打印 -->
        <el-dialog title="打印" :visible.sync="printShow" width="1200px" :close-on-click-modal="false">
            <div style="margin-top:20px;margin-left:900px;margin-bottom:20px">
                <el-button class="btn-t-info" type="info" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
            </div>
            <v-print :doPrint.sync="print">
                <div id="demo" class="demo">
                    <div>
                        <div class="table">
                            <table width="100%" border="1" cellpadding="0" cellspacing="0">
                                <tr>
                                    <th>SKF</th>
                                    <th colspan="3" rowspan="3">Special Withdraw Requisition
                                        <br><span>采购退货单</span>
                                    </th>
                                    <th rowspan="2" style="font-size: 12px">ForM No.</th>
                                    <th colspan="2" style="font-size: 12px">Quaity Document Ref</th>
                                </tr>
                                <tr>
                                    <th rowspan="2" style="font-size: 12px">SKF SXC</th>
                                    <th style="font-size: 12px">Doc.Name</th>
                                    <th style="font-size: 12px">Section</th>
                                </tr>
                                <tr>
                                    <th style="font-size: 12px">Revision No.</th>
                                    <th style="font-size: 12px">Date（YY.MM）</th>
                                    <th style="font-size: 12px">Pages</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div>
                        <div class="table">
                            <table width="100%" border="1" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td>申请单号</td>
                                    <td colspan="2">{{srCode}}</td>
                                    <td>部门</td>
                                    <td></td>
                                    <td>成本中心</td>
                                    <td>{{workCenter}}</td>
                                    <td>日期</td>
                                    <td>{{timeDate}}</td>
                                </tr>
                                <tr>
                                    <td>工单号</td>
                                    <td colspan="">物 料 编 号</td>
                                    <td>物料批次</td>
                                    <td colspan="2">退 料 库 位</td>
                                    <td>规值</td>
                                    <td>数量</td>
                                    <td colspan="2">退 料 原 因</td>
                                </tr>
                                <tr v-for="(item, index) in printList" :key="index" class="">
                                    <td></td>
                                    <td colspan="">{{item.matCode}}</td>
                                    <td colspan="">{{item.batchNo}}</td>
                                    <td colspan="2">{{item.laCodeAdvise}}-{{item.boxBarcode}}</td>
                                    <td>{{item.matSpecs}}</td>
                                    <td>{{item.matQuan}}</td>

                                    <td colspan="2">{{item.wtName}}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td colspan=""></td>
                                    <td colspan=""></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>合计</td>
                                    <td colspan="2"></td>
                                    <td colspan="2">{{boxCount}}箱</td>
                                    <td>{{boxQuan}}</td>
                                    <td></td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>库管员确认</td>
                                    <td colspan="4"></td>
                                    <td>供应商确认</td>
                                    <td colspan="3"></td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="2">{{personName}}</td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                </tr> -->
                            </table>
                            <div style="margin-left: 60%;font-size:16px;margin-top:1%">{{supplyName}}</div>
                        </div>
                    </div>
                </div>
            </v-print>
            <div style="margin-top: 50px;height:80px">
                <!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false,printObjList()">打印</el-button> -->
            </div>

        </el-dialog>
    </div>
</template>
<style>
    .el-table .success-row {
        color: #ff0000;
    }
</style>
<script>
    import vPrint from 'syl-vue-printer'
    import plabel from '../../components/public/plabel.vue';
    import moment from 'moment'
    export default {
        components: {
            plabel,
            vPrint
        },
        name: "PurchaseReturn",
        data() {
            return {
                //打印
                print: false,
                printShow: false,
                printList: [],
                timeDate: '',
                person: localStorage.getItem("user"),
                workCenter: '', //成本中心
                srCode: '',//申请单号
                boxCount: '',//箱数
                boxQuan: '',//总数量
                supplyName: '',//供应商名称

                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                // 筛选条件
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "", //工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    srCode: "", //退货编号
                    matCode: "", //物料编号
                    matName: "", //物料描述
                    batchNo: "", //批次号
                    srStatus: "CREATE,PICK,PICKING,PICKCOMPLETE,TEMP", //退货状态
                    orderCode: "", //订单编号
                    date: [],
                    saleFlag:"",
                    svName:"",
                },

                // 详情
                mainDetails: [],
                detailsDialogShow: false,
                //全选
                checkList: [],
                checkLists: [],

                //退货
                warehouseList: [],
                whInventoryDialog: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                },
                whInventorySearch: {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: "", // 通道编号
                    opCode: "",
                    lcCode: "", //	库位编号
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "NORMAL", //	库存状态
                    boxBarcode: "", //	箱号
                    saleFlag: "",
                    verdorCode:"",
                    checkResult:"20",
                    date: [],
                },
                whCodeId: "",
                whInventoryShow: false,
                checkListWh: [],
                returnNumber: "", //退货数量
                buttonShow: true,

                orderList: [],
                vendorList:[],
                downloadLoading: false, //下载
                confrimReturns: false, //下载

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                personName:"", //申请人名字
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
            whInventorySearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getStockList(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getTableData()
                }, 1000)
            },
            
            //根据操作人获取操作人名称
            getPersonName(person){
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {
                            pageNum: 1,
                            pageSize: 99999,
                            userAccount: person || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.personName = resp.data.list[0].userName || "";
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });     
            },

            /**
             * 来料收货待检超过5天的 标红
             */
            tableRowClassNames({row}) {
                var dates = new Date(row.createTime).getTime(); //日期转时间戳
                // var end = dates.getTime(); 
                var today = new Date().getTime(); //当前的时间戳
                var days = (today - dates) / (1000 * 3600 * 24);
                if ((days < -7 && row.srStatus == 'WAITOUT' && row.internalFlag == false) || (days < -30 && row.srStatus == 'WAITOUT' && row.internalFlag == true)) {
                    return "success-row";
                }
                if (days > 7 && row.srStatus == "TEMP") {
                    return "success-row";
                }
            },

            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },

            getPrintList() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选退货单！",
                        type: "warning",
                    });
                    return;
                } else if (this.checkList.length > 1) {
                    this.$message({
                        message: "只能选择一个退货单！",
                        type: "warning",
                    });
                    return;
                }

                var srCode = "";
                this.checkList.forEach((item) => {
                    srCode = item.srCode;
                })
                this.prints(srCode);

            },

            prints(srCode) {
                this.printShow = true;

                this.$http
                    .request({
                        url: "/api/order/getStockReturnDetails",
                        method: "GET",
                        params: {
                            srCode: srCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data != null) {
                                this.printShow = true;
                                this.printList = resp.data;
                                this.getPersonName(this.printList[0].person);
                                this.workCenter = resp.data[0].workCenter;
                                this.srCode = srCode;
                                this.getTime();

                                this.boxCount = this.printList.length;
                                this.boxQuan = 0;

                                for(var index in this.printList){
                                    this.boxQuan += this.printList[index].matQuan
                                }

                                if(this.printList.length > 0){
                                    this.supplyName = this.printList[0].svName
                                }

                            } else {
                                this.$message({
                                    message: "未找到拣货详情打印记录！",
                                    type: "warning",
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            getTableData() {
                this.$http
                    .request({
                        url: "/api/order/getStockReturnPage",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                            fcCode: this.mainSearch.fcCode || null,
                            whCode: this.mainSearch.whCode || null,
                            srCode: this.mainSearch.srCode || null,
                            matCode: this.mainSearch.matCode || null,
                            matName: this.mainSearch.matName || null,
                            batchNo: this.mainSearch.batchNo || null,
                            srStatus: this.mainSearch.srStatus || null,
                            orderCode: this.mainSearch.orderCode || null,
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                            saleFlag:this.mainSearch.saleFlag,
                            svName:this.mainSearch.svName,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            //禁选
            checkboxSelect(row, rowIndex) {
                // console.log("row", row.srStatus)
                // if (row.srStatus == 'CREATE' || row.srStatus == 'WAITOUT') {
                if (row.srStatus == "CREATE" || row.srStatus == "CONFIRM" || row.srStatus == "WAITOUT" || row.srStatus == 'TEMP') {
                    return true; // 禁用
                } else {
                    return false; // 不禁用
                }
            },
            /**
             * 全选
             */
            selectAll(val) {
                this.checkList = val;
            },
            checkAllWh(val) {
                this.checkListWh = val;
            },

            /**
             * 采购退货修改计划退货数量
             */
            updateStockReturn(row) {
                this.$http
                    .request({
                        url: "/api/order/updateStockReturn",
                        method: "PUT",
                        showLoading: true,
                        data: row,
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.$set(row, "clicktext", false);
                            this.$message({
                                message: "提交成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
            },

            /**
             * 退货确认
             */
            ReturnConfirmation() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选退货单！",
                        type: "warning",
                    });
                    return;
                }
                for (let e of this.checkList) {
                    if (e.srStatus != "WAITOUT") {
                        this.$message({
                            message: "请勾选待出库的退货单！",
                            type: "warning",
                        });
                        return;
                    }
                }
                this.$confirm("是否确认完成?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/ReturnConfirmation",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "提交成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：退货减库存操作成功";
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：退货减库存操作失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            ReturnConfirmationVR() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选退货单！",
                        type: "warning",
                    });
                    return;
                }
                for (let e of this.checkList) {
                    if (e.srStatus != "TEMP" && e.srStatus != "WAITOUT") {
                        this.$message({
                            message: "请勾选待出库或暂存的退货单！",
                            type: "warning",
                        });
                        return;
                    }
                }
                this.$confirm("是否确认退货?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/ReturnConfirmationVR",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "提交成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：退货减库存操作成功";
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：退货减库存操作失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 提交拣货单
             */
            submitPicking(obj) {
                // if (this.checkList.length == 0) {
                //     this.$message({
                //         message: "请勾选退货单！",
                //         type: "warning",
                //     });
                //     return;
                // }

                // if (this.checkList.length > 1) {
                //     this.$message({
                //         message: "只能选择一个退货单！",
                //         type: "warning",
                //     });
                //     return;
                // }
                // let returnPage = this.checkList[0];

                this.$confirm("是否确认提交拣货单?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/submitPicking",
                                method: "POST",
                                showLoading: true,
                                data: obj,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                },
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "提交成功，开始拣货",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：采购退货提交拣货单操作成功";
                                    var srCode = "";
                                    this.mainDetails.forEach((item) => {
                                        srCode = item.srCode;
                                    })
                                    this.prints(srCode);

                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：采购退货提交拣货单操作失败";
                                }
                                this.logContent = JSON.stringify(this.checkListss);
                                this.systemLog();
                                this.getTableData();
                                this.dialogClose();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 详情
             */
            detailsDialog(row) {
                if (row.srStatus == 'CREATE') {
                    this.buttonShow = false;
                } else {
                    this.buttonShow = true;
                }
                this.checkLists = row;
                this.detailsDialogShow = true;
                this.getStockReturnList(row);
            },
            getStockReturnList(row) {
                this.$http
                    .request({
                        url: "/api/order/getStockReturnDetails",
                        method: "GET",
                        params: {
                            srCode: row.srCode || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainDetails = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            /**
             * 删除
             */
            deleteReturn(row) {
                this.$confirm("是否确认删除?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/deleteStockReturn",
                                method: "DELETE",
                                params: {
                                    srCode: row.srCode || null,
                                },
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "提交成功",
                                        type: "success",
                                    });
                                    this.getTableData();
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                }
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });

            },
          saleFlag(orderCode,type){
              if(orderCode == undefined && type == 'P'){
                 return false;
              }
              if(orderCode == undefined && type == 'C'){
                return true;
              }
              if( orderCode.substring(0,1)==type){
                return true;
              }
               return false;
          },

            /**
             * 确认退货
             */
            confirmStockReturn() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选退货单！",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkList.length > 1) {
                    this.$message({
                        message: "只能选择一个退货单！",
                        type: "warning",
                    });
                    return;
                }
                let srCode = this.checkList[0].srCode;
                let srStatus = this.checkList[0].srStatus;
                if (srStatus != "WAITOUT") {
                    this.$message({
                        message: "当前退货单没有确认拣货",
                        type: "warning",
                    });
                    return;
                }

                this.$confirm("是否确认进行退料操作?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/confirmStockReturn",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    srCode: srCode,
                                    person: localStorage.getItem("user") || "",
                                },
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "退货成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：采购退货退货确认操作成功";
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：采购退货退货确认操作失败";
                                }
                                this.logContent = "srCode" + srCode;
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            dialogClose() {
                this.detailsDialogShow = false;
                this.getTableData()
            },
            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "", //工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    srCode: "", //退货编号
                    matCode: "", //物料编号
                    matName: "", //物料描述
                    batchNo: "", //批次号
                    srStatus: "CREATE,PICK,PICKING,PICKCOMPLETE,TEMP", //退货状态
                    orderCode: "", //订单编号
                    date: [],
                };
            },
            /**
             * 重置
             */
            resetStock() {
                this.whInventorySearch = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: "", // 通道编号
                    opCode: "",
                    lcCode: "", // 库位编号
                    matCode: "", // 物料编号
                    matName: "", // 物料描述
                    batchNo: "", // 批次号
                    wiStatus: "NORMAL", // 库存状态
                    boxBarcode: "", // 箱号
                    verdorCode:"",
                    checkResult:"",
                    date: [],
                };
            },

            /**
             * 获取通道数据
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

          /**
           * 获取供应商数据
           */
          getVendorAll() {
            this.$http
                .request({
                  url: "/api/vendor/getVendorAll",
                  method: "GET",
                  params: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    whCode: "",
                  },
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    this.vendorList = resp.data.list || [];
                  }
                })
                .catch((error) => {
                  this.loading++;
                });
          },

            //新增盘点计划
            whInventoryOpen() {
                this.whInventoryShow = true;
                this.getStockList();
                this.getWarehouse();
                //this.getOrderProductList();
            },
            whInventoryClose() {
                this.resetStock();
                //this.whInventoryDialog.data = [];
                this.getTableData();
                this.whInventoryShow = false;
            },

            //库存列表
            getStockList() {
                this.$http
                    .request({
                        url: "/api/order/getStockList",
                        method: "GET",
                        params: {
                            pageNum: this.whInventoryDialog.nowPage, //	页号
                            pageSize: this.whInventoryDialog.pageSize, //	页大小
                            fcCode: this.whInventorySearch.fcCode || null, //	工厂编号
                            opCode: this.whInventorySearch.opCode || null,
                            whCode: this.whInventorySearch.whCode || null, //	通道编号
                            lcCode: this.whInventorySearch.lcCode,
                            lcType: "JY,AD,FLOOR,GL",
                            matCode: this.whInventorySearch.matCode || null, //	物料编号
                            matName: this.whInventorySearch.matName || null, //	物料描述
                            batchNo: this.whInventorySearch.batchNo || null, //	批次号
                            wiStatus: this.whInventorySearch.wiStatus || null, //	库存状态
                            boxBarcode: this.whInventorySearch.boxBarcode || null, //	箱号
                            saleFlag: this.whInventorySearch.saleFlag || null, //
                            verdorCode:this.whInventorySearch.verdorCode || null, //
                            checkResult:this.whInventorySearch.checkResult || null,
                            beginTime: this.whInventorySearch.date ?
                                this.whInventorySearch.date[0] : null,
                            endTime: this.whInventorySearch.date ?
                                this.whInventorySearch.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.whInventoryDialog.data = res.data.list || [];
                            this.whInventoryDialog.total = res.data.total;
                            if (this.whInventoryDialog.data.length > 0) {
                                for (let e of this.whInventoryDialog.data) {
                                    this.$set(e, 'returnNum', e.matAvaliableQuan)
                                }
                            }
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 退货数量不能大于物料数量
             */
            maxReturnNum(val, index) {
                let integer = /^(-|\+)?\d+$/;
                if (integer.test(val)) {
                    if (this.whInventoryDialog.data[index].matAvaliableQuan == 0) {
                        this.whInventoryDialog.data[index].returnNum = parseInt(val);
                    } else {
                        this.whInventoryDialog.data[index].returnNum = parseInt(val);
                        this.$nextTick(() => {
                            let newVal = Math.min(parseInt(val), this.whInventoryDialog.data[index].matAvaliableQuan);
                            this.whInventoryDialog.data[index].returnNum = newVal;
                        });
                    }
                }
            },

            //判断数组中的数据是否相同
            isAllEqual(array) {
                if (array.length > 0) {
                    return !array.some(function(value, index) {
                        return value !== array[0];
                    });
                } else {
                    return true;
                }
            },

            /**
             * 确认退料
             */
            confrimReturn() {
                if (this.checkListWh.length == 0) {
                    this.$message({
                        message: "请选择要退货的订单",
                        type: "warning",
                    });
                    return;
                }

                let orderCodes = [];
                let matCods= [];
                this.checkListWh.forEach((element) => {
                    orderCodes.push(element.orderCode)
										matCods.push(element.matCode)
                });
                if (this.isAllEqual(orderCodes) == false) {
                    this.$message({
                        message: "请选择相同采购订单",
                        type: "warning",
                    });
                    return;
                }
                if (this.isAllEqual(matCods) == false) {
                    this.$message({
                        message: "请选择相同物料",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListWh.every((e) => {
                    if (e.matAvaliableQuan < e.returnNum) {
                        this.$message({
                            message: "退货数量大于库存可用数量",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.confrimReturns = true;
                this.$confirm("是否确认筛选结果进行退料操作?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/insertStockReturn",
                                method: "POST",
                                showLoading: true,
                                data: this.checkListWh,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：采购退货申请退料成功";
                                    this.whInventoryClose();     
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：采购退货申请退料失败";
                                }
                                this.confrimReturns = false;
                                this.logContent = JSON.stringify(this.checkListWh);
                                this.getTableData();
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.confrimReturns = false;
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.confrimReturns = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            tabClick(row) {
                this.$set(row, "clicktext", true);
            },

            /**
             * 查询订单
             */
            getOrderProductList() {
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchaseList",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.orderList = res.data.list;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.mainSearch.fcCode || null,
                    whCode: this.mainSearch.whCode || null,
                    srCode: this.mainSearch.srCode || null,
                    matCode: this.mainSearch.matCode || null,
                    matName: this.mainSearch.matName || null,
                    batchNo: this.mainSearch.batchNo || null,
                    srStatus: this.mainSearch.srStatus || null,
                    orderCode: this.mainSearch.orderCode || null,
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    saleFlag:this.mainSearch.saleFlag,
                    svName:this.mainSearch.svName,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/order/getStockReturnPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.srStatus == 'CREATE') {
                            c['srStatus'] = '创建'
                        } else if (c.srStatus == 'PICK') {
                            c['srStatus'] = '提交拣配'
                        } else if (c.srStatus == 'PICKING') {
                            c['srStatus'] = '拣配中'
                        } else if (c.srStatus == 'WAITOUT') {
                            c['srStatus'] = '待出库'
                        } else if (c.srStatus == 'OUTPUT') {
                            c['srStatus'] = '已出库'
                        }else if (c.srStatus == 'TEMP') {
                            c['srStatus'] = '暂存'
                        } else if (c.srStatus == 'TEMPOUT') {
                            c['srStatus'] = '完成'
                        } else if (c.srStatus == 'CONFIRM') {
                            c['srStatus'] = '完成'
                        }
                      if(c.saleFlag == true){
                        c['saleFlag']= '寄售仓';
                      }else if(c.saleFlag == false){
                        c['saleFlag']= '非寄售仓';
                      }
                    })
                    const tHeader = ['通道编号', '物料编号', '物料描述', '箱原始数量', '退货数量', '拣货数量', '订单编号', '退料单', '状态',  '退货日期',
                        '退货人','仓库类型','供应商'
                    ]
                    const filterVal = ['whCode', 'matCode', 'matName', 'matOldQuan', 'matQuan', 'matPickQuan', 'orderCode', 'srCode', 'srStatus',  'createTime',
                        'person','saleFlag','svName'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '采购退货'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_return：导出采购退货记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "采购退料",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getWarehouse();
            this.getVendorAll();
            /* 获取首页的数据 */
            this.getTableData();
        },
    };
</script>


<style lang="scss" scoped>
    .div div {
        width: 170px;
        height: 50px;
        /* border: 1px solid black; */
        margin-left: 10px;
        margin-top: 10px;
        float: left;
        font-weight: 550;
        font-size: 18px;
    }

    .table table {
        margin-top: 3px;
    }

    .table table tr td {
        width: 130px;
        height: 50px;
        border: 1px solid black;
        text-align: center;
        font-size: 14px;
        font-weight: 800;
        color: black;
    }

    .table table tr th {
        width: 175px;
        height: 50px;
        border: 1px solid black;
        font-weight: 800;
        font-size: 18px;
        color: black;
    }

    .td td {
        font-weight: 800;
        color: black;
    }

    .color {
        background: rgb(194, 192, 192);
        color: black;
    }
</style>